import React, { useState } from "react";
import "./index.less";
import banerText from "static/img/banerText.png";
import phoneBanner from "static/img/phoneBanner.jpg";
import { Button, Input,message } from "antd";

export default function Banner(props) {
  // let { onSearch } = props;
  const [searchText, setSearchText] = useState('')
  const onChange = (e) => {
    setSearchText(e?.target?.value)
  }
  const onSearch =()=>{
    if(searchText == ''){
      message.warning('请输入搜索关键字')
      return
    }
    localStorage.setItem('searchText', searchText)
		window.location.href = '/#/search'
  }
  const onKeyPress = (e) => {
		if (e.key === 'Enter') {
			onSearch();
		}
	};
  return (
    <div className="banner">
      <div className="banner-top">
        <div className="banner-text box">
          <p><img src={banerText} /></p>
        </div>
        <div className="banner-phone-text">
          <h3>深耕行业，加速交易平台创新</h3>
          <p>升级数字底座，构建数字化采购体系</p>
        </div>
        <div className="banner-search-box box">
          <Input placeholder="请输入关键字" onChange={onChange} onKeyPress={onKeyPress} />
          <Button className="btn btn-default" onClick={onSearch}>搜索</Button> 
        </div>
      </div>
      <div className="banner-phone">
        {/* <img src={phoneBanner} /> */}
      </div>
    </div>
  );
}
